import { media } from '@hellodarwin/core/lib/theme/mixins/responsive';
import styled from 'styled-components';
export const SmallIntroContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.md}px;

  z-index: 1;
  max-width: 400px;
  flex-shrink: 0;
  width: 100%;

  ${media.tablet `
    gap: ${({ theme }) => theme.spacing.sm}px;
    flex-direction: column;
    
    `}
  ${media.xl `
    max-width: 100%;
    
    `}
`;
